import {createSvgIcon} from '../create-svg-icon';

export const FunctionsIcon = createSvgIcon(
  <path d="M18 4H6v2l6.5 6L6 18v2h12v-3h-7l5-5-5-5h7V4z" />
, 'FunctionsOutlined');
